import React from "react";
import { withRouter } from "react-router";
import moment from "moment";
import "moment/locale/id";

import { useTranslation } from "react-i18next";

export default function CardEvents(props) {
  const {
    data,
    openNotif,
    setOpenLogin,
    setOpenTesti,
    setTestimoniItem,
    eventCode,
    testimoniItem,
    getTestimonials,
  } = props;
  const token = localStorage.getItem("token");
  const { t } = useTranslation();

  const startTime = moment(data?.startDate).unix();
  const endTime = moment(data?.endDate).unix();
  const difTime = endTime - startTime;
  const limitTime = startTime + difTime / 2;
  const currentTime = moment().unix();

  return (
    <div className="card-events">
      <img
        src={`https://fammi.ly/uploads/schedules/images/${data?.cover}`}
        alt={data?.name}
        style={{ width: "100%", height: "auto" }}
      />
      <div className="schedule">
        <div>
          <img src="/assets/images/e_calendar.svg" alt="schedule" />
          <p>
            {moment(data?.startDate).lang(t("lang")).format("ddd, DD MMM YYYY")}
          </p>
        </div>
        <div>
          <img src="/assets/images/e_clock.svg" alt="schedule" />
          <p>
            {moment(data?.startDate).lang(t("lang")).format("HH:mm") +
              "-" +
              moment(data?.endDate).lang(t("lang")).format("HH:mm [WIB]")}
          </p>
        </div>
      </div>
      <div className="status">
        <div>
          <img
            src={`/assets/images/e_${
              data?.zoomStatus === "ended"
                ? "done"
                : data?.zoomStatus !== "opened"
                ? "off"
                : "on"
            }.svg`}
            alt="schedule"
          />
          <p>
            {data?.zoomStatus === "ended"
              ? t("have-done")
              : data?.zoomStatus !== "opened"
              ? t("not-started")
              : t("on-going")}
          </p>
        </div>
        {/* {currentTime > limitTime && (
          <button
            onClick={() => {
              if (token && token !== null) {
                if (
                  data?.feedbackReason !== "" &&
                  data?.feedbackReason !== null
                ) {
                  // window.location.href = "/event-testimonials/"+eventCode+"/"+data?.scheduleId;
                  getTestimonials(data?.scheduleId);
                  return;
                }

                setTestimoniItem({
                  name: data?.name,
                  scheduleId: data?.scheduleId,
                  memberId: token ?? "",
                  score: data?.feedbackRate
                    ? data?.feedbackRate
                    : testimoniItem.score,
                });
                setOpenTesti(true);
                return;
              }
              setOpenLogin(true);
            }}
            // disabled={data?.zoomStatus !== "opened" && data?.providerType !== "offline" }
            className={`cta`}
            style={{ background: "#FD8C25", color: "#FFF", border: "none" }}
          >
            {data?.feedbackReason !== "" &&
              data?.feedbackReason !== null &&
              "Lihat Testimoni"}
            {(data?.feedbackReason == "" || data?.feedbackReason === null) &&
              "Isi Testimoni"}
          </button>
        )} */}
        {/* {currentTime <= limitTime && ( */}
        <button
          onClick={() => {
            window.location.href = `/e/${eventCode}/schedule/${data.scheduleId}`;
            // if (token && token !== null) {
            //   window.location.href = `/e/${eventCode}/schedule/${data.scheduleId}`;
            //   return;
            // }

            // setOpenLogin(true);
          }}
          disabled={
            false
            // data?.zoomStatus !== "opened" && data?.providerType !== "offline"
          }
          className={`cta on 
            } ${data?.providerType}`}
        >
          {t("see-details")}
        </button>
        {/* )} */}
      </div>
    </div>
  );
}
